export default __webpack_public_path__ + "static/media/quickcash-banner.b3c5d8ba.png";